import { useWeb3React } from '@web3-react/core';
import { CopyIcon } from '../../assets/icons';
import Button from '../../components/Button';
import useUserCreatedReferral from '../../hooks/referral/useUserCreatedReferral';
import CopyPopUp from '../../components/CopyPopUp';

const ShareReferral = () => {
    const { account } = useWeb3React();

    const { userCreatedReferral } = useUserCreatedReferral(account);

    return (
        <div className='custom-referral-code'>
            <p>Share your customized referral code</p>
            <div className='referral-code-wrapper'>
                <div className='referral-code'>
                    <div className='truncate'>{window.location.hostname}?</div>
                    <div className='non-truncate'>
                        <span>refCode=</span>
                        <span className='code'>{userCreatedReferral}</span>
                    </div>
                </div>
                <CopyPopUp
                    copyText={`${window.location.hostname}?refCode=${userCreatedReferral}`}
                    trigger={
                        <Button className='share'>
                            Copy
                            <CopyIcon />
                        </Button>
                    }
                >
                    Copied!
                </CopyPopUp>
            </div>
        </div>
    );
};

export default ShareReferral;
